// Countdown labels for "last call" stickers (data-leaving-until = epoch ms): the server renders a value at render time,
// this keeps it accurate when Shopify serves a cached page.
(function () {
  function label(until) {
    var days = Math.ceil((Number(until) - Date.now()) / 86400000);
    if (isNaN(days)) return null;
    if (days <= 1) return "Last day";
    return days + " days left";
  }
  document.querySelectorAll("[data-leaving-until]").forEach(function (el) {
    var text = label(el.getAttribute("data-leaving-until"));
    if (text) el.textContent = el.hasAttribute("data-sentence") ? "Leaving for the archive soon: " + text.toLowerCase() + "." : text;
  });

  // Shop panel in the header closes on Escape and on a click outside it.
  document.querySelectorAll("[data-nav-shop]").forEach(function (el) {
    document.addEventListener("click", function (e) { if (el.open && !el.contains(e.target)) el.open = false; });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && el.open) { el.open = false; el.querySelector("summary").focus(); }
    });
  });

  // Footer country selector submits on change.
  document.querySelectorAll("[data-autosubmit]").forEach(function (el) {
    el.addEventListener("change", function () { el.form && el.form.submit(); });
  });

  // Product page: option buttons drive the hidden variant select, the price, the buttons and the main photo.
  document.querySelectorAll("[data-product]").forEach(function (root) {
    var data = root.querySelector("[data-variants]");
    var select = root.querySelector("[data-variant-select]");
    var options = root.querySelector("[data-options]");
    if (data && select && options) {
      var variants = JSON.parse(data.textContent);
      var radios = [].slice.call(options.querySelectorAll("input[type=radio]"));
      options.hidden = false;
      root.querySelector("[data-variant-fallback]").hidden = true;
      // The submit handler below guides to an unpicked option; the hidden select must not block it first.
      select.required = false;

      var count = variants.length ? variants[0].options.length : 0;
      var form = select.form;
      var selected = function () {
        var sel = [];
        radios.forEach(function (r) { if (r.checked) sel[Number(r.dataset.option)] = r.value; });
        return sel;
      };
      // Unpicked options (size starts unpicked) match any value.
      var matches = function (v, sel) {
        for (var j = 0; j < count; j++) if (sel[j] !== undefined && v.options[j] !== sel[j]) return false;
        return true;
      };
      var missing = function (sel) {
        for (var j = 0; j < count; j++) if (sel[j] === undefined) return j;
        return -1;
      };
      var find = function (sel) {
        if (missing(sel) >= 0) return null;
        for (var i = 0; i < variants.length; i++) if (matches(variants[i], sel)) return variants[i];
        return null;
      };
      var optionName = function (j) {
        var legend = options.querySelector('[data-option-set="' + j + '"] legend');
        return legend ? legend.firstChild.textContent.trim().toLowerCase() : "option";
      };
      var update = function (byUser) {
        var sel = selected(), v = find(sel), gap = missing(sel);
        root.querySelectorAll("[data-option-label]").forEach(function (el) { el.textContent = sel[Number(el.dataset.optionLabel)] || ""; });
        radios.forEach(function (r) {
          var alt = sel.slice();
          alt[Number(r.dataset.option)] = r.value;
          var ok = variants.some(function (m) { return m.available && matches(m, alt); });
          r.parentNode.classList.toggle("is-out", !ok);
        });
        root.querySelectorAll("[data-add]").forEach(function (b) {
          b.disabled = gap < 0 && (!v || !v.available);
          b.textContent = gap >= 0 ? "Choose a " + optionName(gap) : !v ? "Unavailable" : v.available ? "Add to cart" : "Sold out";
        });
        root.querySelectorAll("[data-variant-title]").forEach(function (el) { el.textContent = sel.filter(Boolean).join(" / "); });
        select.value = v ? v.id : "";
        if (!v) return;
        root.querySelectorAll("[data-price]").forEach(function (el) { el.textContent = v.price; });
        if (!byUser) return;
        history.replaceState(null, "", location.pathname + "?variant=" + v.id);
      };
      var showPhoto = function () {
        var sel = selected();
        var v = variants.filter(function (m) { return m.media && matches(m, sel); })[0];
        var main = root.querySelector("[data-gallery] .visual");
        var img = main && main.querySelector("img");
        if (v && img && main.dataset.mediaId !== String(v.media.id)) {
          main.dataset.mediaId = v.media.id;
          img.srcset = v.media.srcset;
          img.src = v.media.src;
          img.alt = v.media.alt;
          main.parentNode.scrollTo({ left: 0, behavior: "smooth" });
        }
      };
      // Add to cart with an option still unpicked: take the buyer to that option instead.
      form.addEventListener("submit", function (e) {
        var gap = missing(selected());
        if (gap < 0) return;
        e.preventDefault();
        var set = options.querySelector('[data-option-set="' + gap + '"]');
        set.classList.add("is-needed");
        set.scrollIntoView({ behavior: "smooth", block: "center" });
        set.querySelector("input").focus({ preventScroll: true });
      });
      radios.forEach(function (r) {
        r.addEventListener("change", function () {
          r.closest("[data-option-set]").classList.remove("is-needed");
          update(true);
          showPhoto();
        });
      });
      update(false);
    }

    if (!("IntersectionObserver" in window)) return;

    // Mobile: bar with price and Add to cart while the main button is off screen.
    var bar = root.querySelector("[data-buybar]");
    var mainAdd = root.querySelector(".buy [data-add]");
    if (bar && mainAdd) {
      new IntersectionObserver(function (entries) {
        var off = !entries[0].isIntersecting;
        bar.classList.toggle("is-on", off);
        document.body.classList.toggle("has-buybar", off);
      }).observe(mainAdd);
    }

    // Mobile: dots under the swipe gallery.
    var gallery = root.querySelector("[data-gallery]");
    var dots = root.querySelector("[data-gallery-dots]");
    if (gallery && dots && gallery.children.length > 1) {
      var items = [].slice.call(gallery.children);
      items.forEach(function () { dots.appendChild(document.createElement("span")); });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var i = items.indexOf(en.target);
          [].forEach.call(dots.children, function (d, k) { d.classList.toggle("is-on", k === i); });
        });
      }, { root: gallery, threshold: 0.6 });
      items.forEach(function (el) { io.observe(el); });
    }
  });
})();
